import * as constants from './constants';

export const showSuccessNotification = (payload) => ({
  type: constants.SHOW_SUCCESS_NOTIFICATION,
  payload,
});

export const showErrorNotification = (payload) => ({
  type: constants.SHOW_ERROR_NOTIFICATION,
  payload,
});

export const showWarningNotification = (payload) => ({
  type: constants.SHOW_WARNING_NOTIFICATION,
  payload,
});

export const setViewMode = (payload) => ({
  type: constants.SET_VIEW_MODE,
  payload,
});

export const showContentOverlay = () => ({ type: constants.SHOW_CONTENT_OVERLAY });
export const hideContentOverlay = () => ({ type: constants.HIDE_CONTENT_OVERLAY });

export const showAppOverlay = () => ({ type: constants.SHOW_APP_OVERLAY });
export const hideAppOverlay = () => ({ type: constants.HIDE_APP_OVERLAY });

export const disableEntitiesScroll = () => ({ type: constants.DISABLE_ENTITIES_SCROLL });
export const enableEntitiesScroll = () => ({ type: constants.ENABLE_ENTITIES_SCROLL });
